import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import ScanResultView from "@/components/ScanResultView";

export default function ScanResult() {
  const { id } = useParams();
  const [scan, setScan] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/scans/${id}`)
      .then((r) => setScan(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [id]);

  if (error) return <div className="min-h-[calc(100vh-3.5rem)] flex items-center justify-center text-[#E03E3E]" data-testid="scan-error-state">{error}</div>;
  if (!scan) return <div className="min-h-[calc(100vh-3.5rem)] flex items-center justify-center text-[#9B9A97] text-sm" data-testid="scan-loading">Loading scan…</div>;

  return <ScanResultView scan={scan} showGuestBanner={false} backHref="/dashboard" />;
}
